import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";

const useBlueChipStyles = makeThemedStyles("BlueChip", (theme) => ({
  root: {
    color: "rgba(76, 81, 87, 1)",
    padding: "0.37em 1.33em",
    background: "rgba(225, 245, 255, 1)",
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "1.25em",
  },
}));

const BlueChip = (props: React.PropsWithChildren<{}>) => {
  const styles = useBlueChipStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default BlueChip;
